import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math.color';
import type { Scene } from '@babylonjs/core/scene';

/**
 * A self-lit "neon" material: bright emissive, no lighting, near-black diffuse.
 * GlowLayer picks up the emissive automatically for the Tron bloom.
 */
export function neonMaterial(
  scene: Scene,
  hex: string,
  intensity = 1,
  name = `neon-${hex}`,
): StandardMaterial {
  const m = new StandardMaterial(name, scene);
  const c = Color3.FromHexString(hex).scale(intensity);
  m.emissiveColor = c;
  m.diffuseColor = new Color3(0, 0, 0);
  m.specularColor = new Color3(0, 0, 0);
  m.disableLighting = true;
  return m;
}

/** A dark structural material (platform bodies); edges carry the neon. */
export function darkMaterial(scene: Scene, name = 'dark'): StandardMaterial {
  const m = new StandardMaterial(name, scene);
  m.emissiveColor = new Color3(0.02, 0.05, 0.09);
  m.diffuseColor = new Color3(0, 0, 0);
  m.specularColor = new Color3(0, 0, 0);
  m.disableLighting = true;
  return m;
}
